import cn from 'classnames';
import React from 'react';
import { connect } from 'react-redux';
import * as actions from 'actions/inPersonTraining/eventOverview/attendees';
import Loadable from 'components/shared/loadable';
import Table from 'components/shared/table';
import AttendanceRowMultipleColumn from './AttendanceRowMultipleColumn';

const MultiSessionAttendanceTable = ({
  attendances,
  lastSession,
  filters,
  loading,
  onPageChange,
  onPerPageChange,
  updateAttendees,
  sessions,
  isMultiSession,
}) => {
  const attendanceTaken = lastSession && lastSession.attendance_taken;

  return (
    <Table alternate className="AttendanceTable">
      <Loadable loading={loading}>
        <Table.Header className="EventSessionOverview-attendanceSessionHeader pr-8 pl-8">
          <Table.Body.Cell>
            <div className="d-f jc-l">
              {t('in_person_training.event_overview.attendances.name')}
            </div>
          </Table.Body.Cell>
          <Table.Body.Cell>
            <div
              className={cn('d-f', {
                'jc-l': !attendanceTaken,
              })}
            >
              {t('in_person_training.attendance.headers.rsvp')}
            </div>
          </Table.Body.Cell>
          <Table.Body.Cell>
            <div className="d-f jc-l">
              {t('in_person_training.event_overview.session.title')}
            </div>
          </Table.Body.Cell>
          <Table.Body.Cell>
            <div className="d-f jc-l">
              {t('in_person_training.attendance.headers.attendance')}
            </div>
          </Table.Body.Cell>
        </Table.Header>
        {attendances.data.map(attendance => (
          <AttendanceRowMultipleColumn
            updateAttendance={updateAttendees}
            key={attendance.id}
            attendance={attendance}
            attendances={attendances}
            sessions={sessions}
            isMultiSession={isMultiSession}
          />
        ))}
      </Loadable>
      <Table.Pagination
        className="pt-16 pb-16 p-24 bt-gray-lighter"
        onPageChange={onPageChange}
        onPerPageChange={onPerPageChange}
        page={filters.page}
        pageCount={attendances.totalPages}
        perPage={filters.perPage}
      />
    </Table>
  );
};

const mapStateToProps = ({ attendees, event }) => ({
  attendances: attendees.attendances,
  filters: attendees.filters,
  loading: attendees.loading,
  lastSession: event.last_session,
});

const mapDispatchToProps = {
  onPageChange: page => actions.updateFilters({ page }),
  onPerPageChange: perPage => actions.updateFilters({ perPage }),
  updateAttendees: () => actions.updateAttendees(),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MultiSessionAttendanceTable);
